import { useNavigate, useLocation } from 'react-router-dom';
import { IRowData, MenuActionIds, useAppDispatch } from '../../../../base';
import {
    ITransferCandidateModalData,
    IUpdateJobApplicationStatusAction,
    jobApplicationActions,
} from '../../../../actions';
import { JobApplicationStatusUpdateValues } from '../../../../common';
import { RoutePaths } from '../../../../routes/RoutePaths';

export const useTableCallbacks = (isSavedForLater: boolean) => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();

    const onRowClick = (item: IRowData) => {
        const existingQueryParams = new URLSearchParams(location.search);
        navigate(
            isSavedForLater
                ? `${RoutePaths.jobApplications}/${item?.data?.id}?${existingQueryParams.toString()}`
                : `${item?.data?.id}?${existingQueryParams.toString()}`
        );
    };

    const onMenuItemClick = (
        _cellId: number,
        row: Record<string, string> | undefined,
        actionId: string | undefined
    ) => {
        const payload: IUpdateJobApplicationStatusAction = {
            status: row?.status as JobApplicationStatusUpdateValues,
            stepId: row?.stepId ? parseInt(row.stepId) : 0,
        };
        switch (actionId) {
            case MenuActionIds.Reject:
                dispatch(
                    jobApplicationActions.setRejectApplicationModalData(payload)
                );
                dispatch(
                    jobApplicationActions.setIsRejectApplicationModalOpen(true)
                );
                break;
            case MenuActionIds.Transfer: {
                const transferData: ITransferCandidateModalData = {
                    applicationId: Number(row?.id),
                    candidateName: row?.name ?? '',
                };
                dispatch(
                    jobApplicationActions.setTransferCandidateModalData(
                        transferData
                    )
                );
                dispatch(
                    jobApplicationActions.setIsTransferCandidateModalOpen(true)
                );
                break;
            }
            case MenuActionIds.Withdraw:
                payload.status = JobApplicationStatusUpdateValues.withdraw;
                dispatch(
                    jobApplicationActions.updateJobApplicationStatus(payload)
                );
                break;
            default:
                break;
        }
    };

    const onIsSavedButtonClick = (item: IRowData) => {
        dispatch(
            jobApplicationActions.saveForLater({
                id: Number(item.data.id),
                isSaved:
                    item.data.isSavedIconName === 'BookmarkFilledIcon'
                        ? true
                        : false,
            })
        );
    };

    return { onRowClick, onMenuItemClick, onIsSavedButtonClick };
};
